import { createGtm as Gtm, GtmEvents } from '@outputinc/o-analytics'

const gtmContainerId = import.meta.env.VITE_OUTPUT_GTM_CONTAINER_ID
const gtmEnvironmentId = import.meta.env.VITE_OUTPUT_GTM_ENV_ID
const gtmAuthId = import.meta.env.VITE_OUTPUT_GTM_AUTH_ID

// query params for test environments
const queryParams = {
  gtm_auth: gtmAuthId,
  gtm_preview: gtmEnvironmentId,
  gtm_cookies_win: 'x'
}

type GtmClient = ReturnType<typeof Gtm>

// @gtm-support validates the container id against this pattern and throws at
// construction if it is missing or malformed. That happens at module load, so
// an unset id (e.g. in CI/unit tests) would take down every module that imports
// this one. Guard the createGtm call and fall back to a no-op client instead.
const GTM_ID_PATTERN = /^(GTM|G)-[0-9A-Z]+$/

const noopGtmClient: GtmClient = {
  Events: GtmEvents,
  track: () => {},
  install: () => {}
}

const gtmClient: GtmClient =
  gtmContainerId && GTM_ID_PATTERN.test(gtmContainerId)
    ? Gtm({
        id: gtmContainerId,
        ...(gtmEnvironmentId && { queryParams })
      })
    : noopGtmClient

export default gtmClient
